import { Button } from "@sameday/ui/controls/button";
import { memo } from "react";
import { useNavigate } from "react-router";
import { SamedayLogoHorizontal } from "@/assets/logos/SamedayLogo";
import { NotFoundVector } from "./NotFoundVector";

export const NotFound = memo(() => {
  // Inlined rather than using the shared `useNavigateBack`: that hook lives
  // behind the `@hooks` barrel, and this tier must not reach a barrel.
  const navigate = useNavigate();
  const navigateBack = () => navigate(-1);
  return (
    <main className="flex h-screen w-full flex-col items-center justify-center">
      <div className="absolute top-10 left-10">
        <SamedayLogoHorizontal height={40} />
      </div>
      <div className="flex flex-col">
        <div className="flex flex-col align-center gap-8">
          <div className="flex gap-8">
            <NotFoundVector height={80} />
            <div className="flex flex-col gap-4">
              <h1 className="text-4xl font-semibold">Uh-oh!</h1>
              <h2 className="text-xl font-semibold">404 - Page not found</h2>
              <p>This page doesn't exist or was removed</p>
              <div className="flex mt-2">
                <Button variant="default" onClick={navigateBack}>
                  Go back!
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
});
